import React from 'react';
export function Footer() {
  return <footer className="bg-secondary-dark text-white pt-8 md:pt-16 pb-6 md:pb-8 border-t-4 border-primary" data-id="element-107">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-108">
        <div className="text-center mb-6 md:mb-12" data-id="element-109">
          <h2 className="text-xl md:text-2xl font-bold font-serif mb-2 md:mb-4" data-id="element-110">
            GIMNASIA RÍTMICA INFANTIL RESUELTA™
          </h2>
          <p className="text-secondary-light max-w-2xl mx-auto text-sm md:text-base" data-id="element-111">
            El sistema de clases N°1 para instructoras de gimnasia rítmica
            infantil en Argentina. Porque enseñar rítmica no debería costarte
            todas las noches de la semana.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-12 text-xs md:text-sm text-secondary-light mb-6 md:mb-12" data-id="element-112">
          <a href="mailto:contacto@recursosfitness.shop" className="hover:text-white transition-colors" data-id="element-113">
            contacto@recursosfitness.shop
          </a>
          <span className="hidden md:block w-1 h-1 bg-secondary-light rounded-full" data-id="element-114"></span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-115">
            @recursosfitness.ar
          </a>
          <span className="hidden md:block w-1 h-1 bg-secondary-light rounded-full" data-id="element-116"></span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-117">
            recursosfitness.shop
          </a>
        </div>

        <div className="text-center text-xs text-secondary-light/60 pt-4 md:pt-8 border-t border-white/10" data-id="element-118">
          <p data-id="element-119">© RecursosFitness™ 2026 — Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}